var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FrField',{attrs:{"field":_vm.field,"loading":_vm.loading},on:{"search-change":value => _vm.updateValueSearchTerm(value),"valueChange":value => _vm.handleValueChange(value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }